<template>
    <div class="tpl-page-container" style="padding: 0">
        <MainView></MainView>
    </div>
</template>

<script type="text/javascript">
    import MainView from '@/apps/plan/mobile_page/view_mobile_plan.vue'
    export default {
        components: {
            MainView,
        },
    }
</script>
<style type="text/css">
</style>
